module.exports = __webpack_public_path__ + "static/img/20018 (5).6f92e3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20018 (5).jpg
// module id = ebUd
// module chunks = 14